export default function ({ store }) {
    store.dispatch('closeMenu');
}
